var De = Object.defineProperty;
var Fe = (e, t, o) => t in e ? De(e, t, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[t] = o;
var g = (e, t, o) => (Fe(e, typeof t != "symbol" ? t + "" : t, o), o);
import { defineComponent as re, resolveComponent as D, openBlock as u, createElementBlock as c, createElementVNode as N, createVNode as w, normalizeClass as ie, withCtx as F, toDisplayString as T, ref as x, createBlock as U, resolveDynamicComponent as $e, withModifiers as we, createCommentVNode as h, Fragment as q, renderList as G, renderSlot as W, createTextVNode as M, withDirectives as K, vShow as X } from "vue";
import { IconComp as ae, ButtonComp as le, InputComp as Se, SelectItemComp as Ue } from "@protolabs/component-library";
import E from "dropzone";
class _e {
  constructor(t) {
    g(this, "clickable");
    g(this, "maxFiles");
    g(this, "maxFilesize");
    g(this, "acceptedFiles");
    g(this, "url");
    g(this, "params");
    g(this, "autoProcessQueue");
    g(this, "disablePreviews");
    this.clickable = t.clickable, this.maxFiles = t.maxFiles, this.maxFilesize = t.maxFilesize, this.acceptedFiles = t.acceptedFiles, this.disablePreviews = !0, this.url = "/", this.params = {}, this.autoProcessQueue = !1, this.init = t.init;
  }
}
const Ne = re({
  name: "document-card",
  components: {
    IconComp: ae,
    ButtonComp: le
  },
  props: {
    document: {
      type: Object,
      required: !0
    },
    uploading: {
      type: Boolean,
      required: !0
    }
  },
  computed: {
    buttonClasses() {
      return {
        documentCard__close: !0,
        "documentCard__close--disabled": this.uploading
      };
    }
  },
  methods: {
    removeDoc() {
      this.$emit("docRemoved", this.document.uuid);
    }
  }
});
const de = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [n, s] of t)
    o[n] = s;
  return o;
}, Ce = { class: "documentCard" }, Oe = { class: "documentCard__card" }, Me = ["title", "t-sel"];
function Ee(e, t, o, n, s, l) {
  const i = D("icon-comp"), r = D("button-comp");
  return u(), c("div", Ce, [
    N("div", Oe, [
      w(r, {
        blank: "",
        onClick: e.removeDoc,
        class: ie(e.buttonClasses),
        disabled: e.uploading,
        "aria-label": "Remove file",
        "t-sel": `${e.document.filename}-removeFileBtn`
      }, {
        default: F(() => [
          w(i, {
            icon: "close_small",
            label: "Remove"
          })
        ]),
        _: 1
      }, 8, ["onClick", "class", "disabled", "t-sel"]),
      w(i, { icon: "description_large" })
    ]),
    N("p", {
      title: e.document.name,
      class: "documentCard__fileName",
      "t-sel": `${e.document.filename}Label`
    }, T(e.document.name), 9, Me)
  ]);
}
const Re = /* @__PURE__ */ de(Ne, [["render", Ee], ["__scopeId", "data-v-fa7a3c5f"]]);
var z;
(function(e) {
  e.Unknown = "Unknown", e.Standard = "Standard", e.ITAR = "ITAR", e.Military = "Military", e.DualUse = "DualUse";
})(z || (z = {}));
var R = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function k(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ze(e) {
  return e == null;
}
var ke = ze;
const $ = /* @__PURE__ */ k(ke);
async function Ae() {
  try {
    const e = `${window.TasBaseUrl}/api/configuration/documenttypes?api-version=2022.3`, t = await fetch(e);
    return t.status !== 200 ? null : await t.json();
  } catch (e) {
    return console.error(e), null;
  }
}
async function Ie() {
  try {
    const e = `${window.TasBaseUrl}/api/configuration/filetypes?api-version=2022.3`, t = await fetch(e);
    return t.status !== 200 ? null : await t.json();
  } catch (e) {
    return console.error(e), null;
  }
}
async function H(e, t, o, n, s = !1, l = z.Standard, i = void 0) {
  try {
    if ($(e))
      throw new Error("Url is incorrect");
    const r = new FormData();
    r.append("documentType", t), r.append("fileName", o.filename), r.append("name", o.name), r.append("metadataJSON", JSON.stringify(n)), r.append("formFile", o.file), r.append("uploadToRegionalBasedTas", s.toString()), r.append("exportControl", l), i && r.append("securitySameAsAssetId", i);
    const p = await fetch(e, {
      method: "POST",
      body: r
    }), m = await p.text();
    return p.status !== 200 ? {
      status: !1,
      doc: o,
      text: `Failed to upload file(s), reason: ${m}`
    } : {
      status: !0,
      text: "Successful Upload",
      data: n,
      assetId: m,
      doc: o
    };
  } catch (r) {
    return console.error(r), {
      status: !1,
      doc: o,
      text: `Failed to upload file(s), reason: ${r}`
    };
  }
}
const I = Object.freeze({
  AMER: "AMER",
  EMEA: "EMEA",
  NONE: "NONE"
}), y = Object.freeze({
  orderNumberName: "ORDER_NUM",
  orderNumberValue: "Order Number, ex. 1234-567",
  moldNumberName: "MOLD_NUM",
  moldNumberValue: "Mold Number, ex. 123456",
  moldNumRegEx: "^[0-9]+$",
  poNumberName: "PO_NUM",
  default: "Input"
}), Be = Object.freeze([
  "DOC",
  "DOCX",
  "TXT",
  "PDF",
  "PNG",
  "JPG",
  "XLS",
  "XLSX",
  "HTML"
]);
var je = Array.isArray, ue = je;
const Pe = /* @__PURE__ */ k(ue);
var Le = typeof R == "object" && R && R.Object === Object && R, Ve = Le, xe = Ve, qe = typeof self == "object" && self && self.Object === Object && self, Ge = xe || qe || Function("return this")(), pe = Ge, We = pe, Ke = We.Symbol, j = Ke;
function Xe(e, t) {
  for (var o = -1, n = e == null ? 0 : e.length, s = Array(n); ++o < n; )
    s[o] = t(e[o], o, e);
  return s;
}
var He = Xe, J = j, ce = Object.prototype, Je = ce.hasOwnProperty, Qe = ce.toString, _ = J ? J.toStringTag : void 0;
function Ye(e) {
  var t = Je.call(e, _), o = e[_];
  try {
    e[_] = void 0;
    var n = !0;
  } catch {
  }
  var s = Qe.call(e);
  return n && (t ? e[_] = o : delete e[_]), s;
}
var Ze = Ye, et = Object.prototype, tt = et.toString;
function ot(e) {
  return tt.call(e);
}
var nt = ot, Q = j, st = Ze, rt = nt, it = "[object Null]", at = "[object Undefined]", Y = Q ? Q.toStringTag : void 0;
function lt(e) {
  return e == null ? e === void 0 ? at : it : Y && Y in Object(e) ? st(e) : rt(e);
}
var dt = lt;
function ut(e) {
  return e != null && typeof e == "object";
}
var pt = ut, ct = dt, mt = pt, ht = "[object Symbol]";
function ft(e) {
  return typeof e == "symbol" || mt(e) && ct(e) == ht;
}
var me = ft, Z = j, gt = He, yt = ue, vt = me, bt = 1 / 0, ee = Z ? Z.prototype : void 0, te = ee ? ee.toString : void 0;
function he(e) {
  if (typeof e == "string")
    return e;
  if (yt(e))
    return gt(e, he) + "";
  if (vt(e))
    return te ? te.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -bt ? "-0" : t;
}
var Tt = he, Dt = Tt;
function Ft(e) {
  return e == null ? "" : Dt(e);
}
var $t = Ft, wt = $t, St = 0;
function Ut(e) {
  var t = ++St;
  return wt(e) + t;
}
var _t = Ut;
const Nt = /* @__PURE__ */ k(_t);
function Ct(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var fe = Ct, Ot = pe, Mt = function() {
  return Ot.Date.now();
}, Et = Mt, Rt = /\s/;
function zt(e) {
  for (var t = e.length; t-- && Rt.test(e.charAt(t)); )
    ;
  return t;
}
var kt = zt, At = kt, It = /^\s+/;
function Bt(e) {
  return e && e.slice(0, At(e) + 1).replace(It, "");
}
var jt = Bt, Pt = jt, oe = fe, Lt = me, ne = 0 / 0, Vt = /^[-+]0x[0-9a-f]+$/i, xt = /^0b[01]+$/i, qt = /^0o[0-7]+$/i, Gt = parseInt;
function Wt(e) {
  if (typeof e == "number")
    return e;
  if (Lt(e))
    return ne;
  if (oe(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = oe(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Pt(e);
  var o = xt.test(e);
  return o || qt.test(e) ? Gt(e.slice(2), o ? 2 : 8) : Vt.test(e) ? ne : +e;
}
var Kt = Wt, Xt = fe, B = Et, se = Kt, Ht = "Expected a function", Jt = Math.max, Qt = Math.min;
function Yt(e, t, o) {
  var n, s, l, i, r, p, m = 0, C = !1, v = !1, a = !0;
  if (typeof e != "function")
    throw new TypeError(Ht);
  t = se(t) || 0, Xt(o) && (C = !!o.leading, v = "maxWait" in o, l = v ? Jt(se(o.maxWait) || 0, t) : l, a = "trailing" in o ? !!o.trailing : a);
  function f(d) {
    var b = n, S = s;
    return n = s = void 0, m = d, i = e.apply(S, b), i;
  }
  function ye(d) {
    return m = d, r = setTimeout(O, t), C ? f(d) : i;
  }
  function ve(d) {
    var b = d - p, S = d - m, V = t - b;
    return v ? Qt(V, l - S) : V;
  }
  function P(d) {
    var b = d - p, S = d - m;
    return p === void 0 || b >= t || b < 0 || v && S >= l;
  }
  function O() {
    var d = B();
    if (P(d))
      return L(d);
    r = setTimeout(O, ve(d));
  }
  function L(d) {
    return r = void 0, a && n ? f(d) : (n = s = void 0, i);
  }
  function be() {
    r !== void 0 && clearTimeout(r), m = 0, n = p = s = r = void 0;
  }
  function Te() {
    return r === void 0 ? i : L(B());
  }
  function A() {
    var d = B(), b = P(d);
    if (n = arguments, s = this, p = d, b) {
      if (r === void 0)
        return ye(p);
      if (v)
        return clearTimeout(r), r = setTimeout(O, t), f(p);
    }
    return r === void 0 && (r = setTimeout(O, t)), i;
  }
  return A.cancel = be, A.flush = Te, A;
}
var Zt = Yt;
const eo = /* @__PURE__ */ k(Zt), to = () => {
  const e = x(!1), t = x(null), o = () => {
    e.value = !0;
  }, n = (r) => {
    t.value = r.target, e.value = !0, eo(s, 100);
  }, s = () => {
    t.value = null, e.value = !1;
  };
  return {
    dragging: e,
    dragEventTarget: t,
    handleDragOver: o,
    handleDragEnter: n,
    disableDragging: s,
    handleDragLeave: (r) => {
      r.target === t.value && (t.value = null, e.value = !1);
    },
    handleDrop: () => {
      e.value = !1;
    }
  };
}, oo = re({
  name: "tas-upload",
  components: {
    DocumentCard: Re,
    ButtonComp: le,
    InputComp: Se,
    SelectItemComp: Ue,
    IconComp: ae
  },
  props: {
    /**
     * This is to call the correct regional based back end to upload the file. Input "NONE" to use proxy url (local demo page only)
     */
    region: {
      type: String,
      required: !0
    },
    /**
     * If the consumer already has the list of all document types from TAS, pass in and reduce how many TAS calls we make
     */
    documentTypes: {
      type: Array,
      default: void 0
    },
    /**
     * What document type name(s) to use/show. If none provided all shown
     */
    documentTypeNamesProvided: {
      type: Array,
      default: () => []
    },
    /**
     * These are options for metadata to prefill
     * ex: you have an order number already to prefill for the customer so they don't have to type it in
     */
    metadataProvided: {
      type: Array,
      default: () => []
    },
    /**
     * When true, only metadata provided from `metadataProvided` prop will show
     * When false, all the metadata in a document type will show
     * ex: document type has order number and ax order id metadata
     * if prop is true and we only give the order number metadata in `metadataProvided`,
     * 		only order number input will show to user
     * if prop is false and we only give the order number metadata in `metadataProvided`,
     * 		both order number and ax order id inputs will show to user
     */
    showOnlyMetadataProvided: {
      type: Boolean,
      default: !0
    },
    /**
     * This is for dropzone to know what clickable elements we want to open the file explorer for
     */
    clickableElements: {
      type: [Array, String, Boolean, Object],
      default: () => []
    },
    maxFiles: {
      type: Number,
      default: 10
    },
    maxFilesize: {
      type: Number,
      default: 150
    },
    /**
     * This is for dropzone to know what accepted files to accept, a comma separated list of mime types or file extensions
     * ex: 'image/*,application/pdf,.docx'
     */
    acceptedFiles: {
      type: String,
      default: ""
    },
    hideCancelButton: {
      type: Boolean,
      default: !1
    },
    hideButtons: {
      type: Boolean,
      default: !1
    },
    hideDocumentCards: {
      type: Boolean,
      default: !1
    },
    /**
     * Determines if we are an external customer view
     */
    isExternalCustomerView: {
      type: Boolean,
      default: !0
    },
    /**
     * Disables the dropzone from uploading
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * When upload in progress, prevents more files from being dropped or deleted
     */
    submitInProgress: {
      type: Boolean,
      default: !1
    },
    /**
     * Boolean to either use a form around the whole component or not
     */
    useForm: {
      type: Boolean,
      default: !0
    },
    /**
     * Tas ExportControlType to be marked on the tas asset ex Standard/ITAR/Dual Use/Military
     */
    exportControl: {
      type: String,
      default: z.Standard
    },
    /**
     * Temporary prop to upload file to regional TAS to work with v3 uploads
     */
    uploadToRegionalBasedTas: {
      type: Boolean,
      default: !1
    },
    /**
     * Uploads file with the same security as asset id provided
     */
    securitySameAsAssetId: {
      type: String,
      default: void 0
    }
  },
  setup() {
    const e = to();
    return {
      dragging: e.dragging,
      handleDragOver: e.handleDragOver,
      handleDragEnter: e.handleDragEnter,
      handleDragLeave: e.handleDragLeave,
      handleDrop: e.handleDrop
    };
  },
  data() {
    return {
      reRenderComponentKey: 0,
      documentUploads: [],
      dropzone: null,
      hasBeenMounted: !1,
      localDropzoneProps: {},
      documentTypeSelected: null,
      metadata: null,
      documentTypesForDropdown: [],
      tasDocumentTypes: [],
      rules: {
        required: {
          validationFunction: (e) => !!e,
          errorMessageText: this.$t("validation.required")
        }
      },
      errorMessages: [],
      uploading: !1,
      componentLoaded: !1,
      isValidFileDropzoneFunction: E.isValidFile
    };
  },
  async mounted() {
    var l;
    E.autoDiscover = !1;
    const e = this.acceptedFiles ? await Promise.resolve(this.acceptedFiles) : this.stringifyFileTypes(await Ie()), t = this, o = this.clickableElements;
    !this.isExternalCustomerView && o && Pe(o) && (o.push(this.$refs.clickableIcon), o.push(this.$refs.clickableText)), this.localDropzoneProps = new _e({
      acceptedFiles: e,
      clickable: o,
      maxFiles: this.maxFiles,
      maxFilesize: this.maxFilesize,
      init: function() {
        this.on(
          "error",
          (i, r) => t.dropzoneErrorOccured(i, r)
        ), this.on("addedfile", (i) => t.onDropzoneAddedFile(i));
      }
    }), E.isValidFile = this.isValidFile;
    try {
      this.dropzone = new E(
        this.$refs.dropzoneElement,
        this.localDropzoneProps
      );
    } catch (i) {
      console.error("Error creating dropzone for tas upload"), console.error(i);
    }
    if (!$(this.documentTypes))
      this.setTasDocumentTypes(this.documentTypes);
    else if (!this.isExternalCustomerView) {
      const i = await Ae();
      i ? (this.tasDocumentTypes = i, this.mapDocumentTypes()) : console.error("Found no document types from TAS");
    }
    this.disabled && ((l = this.dropzone) == null || l.disable()), this.$emit("uploadComponentLoaded"), this.componentLoaded = !0;
    const n = document.getElementsByClassName("dz-hidden-input")[0].attributes, s = document.createAttribute("t-sel");
    s.value = "tasUploadHiddenFileInput", n.setNamedItem(s);
  },
  unmounted() {
    var e;
    (e = this.dropzone) == null || e.destroy();
  },
  computed: {
    acceptedFileTypesString() {
      return this.passedInFileTypeString.length === 1 ? this.$t("commonComps.documentUpload.weAccept", {
        fileTypes: this.passedInFileTypeString.join(", ")
      }) : this.$t("commonComps.documentUpload.weAcceptPlural", {
        fileTypes: this.passedInFileTypeString.slice(0, -1).join(", "),
        lastFileType: this.passedInFileTypeString.slice(-1)
      });
    },
    showAcceptedFileTypesMsg() {
      var e, t;
      return ((t = (e = this.localDropzoneProps) == null ? void 0 : e.acceptedFiles) == null ? void 0 : t.length) > 0 && !this.documentUploads.length;
    },
    showButton() {
      return this.documentUploads.length > 0 && this.documentTypeSelected && this.metadata && this.inputRulesMet && !this.uploading;
    },
    inputRulesMet() {
      var e;
      return (e = this.metadata) == null ? void 0 : e.every((t) => {
        const o = t.value || "";
        return !t.isRequired && !o ? !0 : t.regexPattern ? t.name === y.moldNumberName ? new RegExp(y.moldNumRegEx).test(o) : new RegExp(t.regexPattern).test(o) : !0;
      });
    },
    showMetadata() {
      return this.metadata && this.metadata.length > 0 && this.metadata.some((e) => !e.hideFieldFromUser);
    },
    showRemoveFiles() {
      return this.documentUploads.length > 0;
    },
    showDocumentTypeSelect() {
      var e;
      return ((e = this.documentTypesForDropdown) == null ? void 0 : e.length) > 1;
    },
    showDocumentTypeLabel() {
      var e;
      return ((e = this.documentTypesForDropdown) == null ? void 0 : e.length) === 1 && !this.isExternalCustomerView;
    },
    showInputs() {
      return this.componentLoaded && (this.showDocumentTypeSelect || this.showDocumentTypeLabel || this.showMetadata);
    },
    url() {
      switch (this.region.toUpperCase()) {
        case I.NONE:
          return "/api/upload";
        case I.AMER:
          return `${window.DocUploadAMER}/api/upload`;
        case I.EMEA:
          return `${window.DocUploadEMEA}/api/upload`;
        default:
          return null;
      }
    },
    mappedMetaData() {
      var e;
      return (e = this.metadata) == null ? void 0 : e.map(
        (t) => ({
          metadataType: t.name,
          value: t.value
        })
      );
    },
    passedInFileTypeString() {
      const e = this.localDropzoneProps.acceptedFiles.split(",").map((t) => t.split("/")[1]).filter((t) => !!t);
      return e && e.length > 0 ? e.map((t) => t.toUpperCase()) : Be;
    },
    isUploading() {
      return this.submitInProgress || this.uploading;
    }
  },
  methods: {
    isValidFile(e, t) {
      const o = this.isValidFileDropzoneFunction(
        e,
        t
      ), n = !$(e == null ? void 0 : e.name) && !$(t) && t.indexOf(".prt") > 0 && new RegExp(".prt.\\d{1,3}$").test(
        e.name.slice(e.name.toLowerCase().indexOf(".prt")).toLowerCase()
      );
      return o || n;
    },
    selectDocumentType(e) {
      this.reRenderComponentKey += 1, this.documentTypeSelected = e, $(e) ? this.metadata = null : this.mapMetadataSelection(e.value);
    },
    mapMetadataSelection(e) {
      var t;
      if (e) {
        const o = [];
        (t = e.allowedMetadata) == null || t.forEach((n) => {
          const s = this.metadataProvided.find(
            (l) => {
              var i;
              return l.metadataName === ((i = n.metadataType) == null ? void 0 : i.name);
            }
          );
          this.showOnlyMetadataProvided && $(s) || o.push({
            ...n.metadataType,
            isRequired: n.isRequired,
            value: (s == null ? void 0 : s.value) ?? void 0,
            disabled: (s == null ? void 0 : s.disabled) ?? !1,
            hideFieldFromUser: (s == null ? void 0 : s.hideFieldFromUser) ?? !1
          });
        }), this.metadata = o.length === 0 ? null : o;
      }
    },
    dropzoneErrorOccured(e, t) {
      const o = this.documentUploads.find((n) => {
        var s;
        return n.uuid === ((s = e.upload) == null ? void 0 : s.uuid);
      });
      o && this.removeDocument(o.uuid), this.$emit("dropzoneError", { doc: o, text: t });
    },
    async uploadOneFile(e, t, o, n) {
      var s;
      try {
        const l = ((s = this.documentTypeSelected) == null ? void 0 : s.text) ?? "", i = this.documentUploads.find((p) => p.uuid === e);
        return i ? (o && (i.filename = o, i.name = o), await H(
          this.url,
          l,
          i,
          t,
          this.uploadToRegionalBasedTas,
          n || this.exportControl,
          this.securitySameAsAssetId
        )) : { status: !1, text: "Failed to find document with given id" };
      } catch (l) {
        return console.error(l), { status: !1, text: `Failed to upload for ${l}` };
      }
    },
    async submitClick() {
      var t;
      const e = [];
      try {
        this.uploading = !0, this.$emit("submit");
        const o = ((t = this.documentTypeSelected) == null ? void 0 : t.text) ?? "";
        for (const n in this.documentUploads) {
          const s = this.documentUploads[n], l = await H(
            this.url,
            o,
            s,
            this.mappedMetaData,
            this.uploadToRegionalBasedTas,
            this.exportControl,
            this.securitySameAsAssetId
          );
          e.push(l);
        }
        e.every((n) => n.status) ? (this.$emit("uploadSuccess", e), this.cancelButton()) : (this.$emit("uploadFailure", e), e.forEach((n) => {
          var s;
          n.status && this.removeDocument((s = n.doc) == null ? void 0 : s.uuid);
        }));
      } catch (o) {
        this.$emit("uploadFailure", [{ status: !1, text: `${o.message}` }]), console.error(o);
      } finally {
        this.uploading = !1;
      }
      return e;
    },
    cancelButton() {
      this.removeAllDocuments(), this.selectDocumentType(this.documentTypeSelected ?? null), this.reRenderComponentKey += 1;
    },
    useRules(e) {
      if (e.name === y.moldNumberName)
        return [
          {
            validationFunction: () => !e.isRequired && !e.value || !!e.value && new RegExp(y.moldNumRegEx).test(e.value),
            errorMessageText: `${this.$t("validation.invalid")}
              ${e.friendlyName}`
          }
        ];
      if (e.regexPattern && e.regexPattern !== "")
        return [
          {
            validationFunction: () => !e.isRequired && !e.value || !!e.value && new RegExp(e.regexPattern ?? "").test(e.value),
            errorMessageText: `${this.$t("validation.invalid")}
              ${e.friendlyName}`
          }
        ];
    },
    onDropzoneAddedFile(e) {
      var o, n, s, l, i, r;
      if (this.isUploading)
        return;
      if ((o = this.dropzone) != null && o.options.maxFiles && this.documentUploads.length >= ((n = this.dropzone) == null ? void 0 : n.options.maxFiles)) {
        this.$emit("maxFilesExceeded", e);
        return;
      }
      if ((s = this.dropzone) != null && s.options.acceptedFiles && !this.isValidFile(e, this.dropzone.options.acceptedFiles)) {
        this.$emit("invalidFileType", e);
        return;
      }
      if ((l = this.dropzone) != null && l.options.maxFilesize && e.upload && e.upload.total > this.dropzone.options.maxFilesize * 1024 * 1024) {
        this.$emit("fileTooBig", e);
        return;
      }
      const t = {
        name: e.name,
        filename: e.name,
        status: e.status,
        uuid: ((i = e.upload) == null ? void 0 : i.uuid) || Nt(),
        file: e
      };
      this.documentUploads.push(t), this.$emit("fileUploaded", {
        id: t.uuid,
        filename: e.name,
        fileSize: (r = e.upload) == null ? void 0 : r.total
      });
    },
    removeDocument(e) {
      var o;
      const t = this.documentUploads.find((n) => n.uuid === e);
      t && (this.documentUploads = this.documentUploads.filter(
        (n) => n.uuid !== e
      ), (o = this.dropzone) == null || o.removeFile(t.file), t.uuid && this.$emit("fileRemoved", { id: t.uuid, filename: t.filename }));
    },
    removeAllDocuments() {
      var e;
      this.documentUploads = [], (e = this.dropzone) == null || e.removeAllFiles(!0);
    },
    getMetaDataTitle(e) {
      switch (e.name) {
        case y.orderNumberName:
          return this.$t("models.selectItem.orderNum");
        case y.moldNumberName:
          return y.moldNumberValue;
        case y.poNumberName:
          return this.$t("views.purchaseOrderBillingEditor.poNumber");
        default:
          return e.friendlyName;
      }
    },
    stringifyFileTypes(e) {
      const t = ["zip"];
      return (e == null ? void 0 : e.reduce((o, n, s) => {
        if (t.includes(n.extension.toLowerCase()))
          return o;
        const l = `.${n.extension}`;
        return s === 0 ? o = l : o += `,${l}`;
      }, "")) ?? "";
    },
    getPlaceholderText(e) {
      return e.name === y.poNumberName ? this.$t("views.purchaseOrderBillingEditor.enter") : `Enter ${e.friendlyName}`;
    },
    mapDocumentTypes() {
      var t;
      let e = this.tasDocumentTypes;
      ((t = this.documentTypeNamesProvided) == null ? void 0 : t.length) > 0 && (e = this.tasDocumentTypes.filter(
        (o) => this.documentTypeNamesProvided.includes(o.name)
      )), this.documentTypesForDropdown = e.map(
        (o) => ({
          text: o.name,
          value: o,
          tSel: `${o.name}Option`
        })
      ), e.length === 1 && this.selectDocumentType(this.documentTypesForDropdown[0]);
    },
    setTasDocumentTypes(e) {
      this.tasDocumentTypes = e, this.mapDocumentTypes();
    }
  },
  watch: {
    showButton(e) {
      this.$emit("readyToSubmit", e);
    },
    documentTypeNamesProvided() {
      this.mapDocumentTypes(), this.reRenderComponentKey += 1;
    },
    metadataProvided() {
      var e;
      this.mapMetadataSelection(((e = this.documentTypeSelected) == null ? void 0 : e.value) ?? null), this.reRenderComponentKey += 1;
    },
    dragging(e) {
      this.$emit("dragging", e);
    },
    disabled(e) {
      var t, o;
      e ? (t = this.dropzone) == null || t.disable() : (o = this.dropzone) == null || o.enable();
    },
    documentTypes(e) {
      this.setTasDocumentTypes(e);
    }
  }
});
const no = {
  key: 1,
  class: "tasUpload__form-providedDoc",
  "t-sel": "documentTypeLabel"
}, so = { key: 2 }, ro = { key: 1 }, io = {
  ref: "clickableIcon",
  class: "tasUpload__upload-icon",
  "t-sel": "uploadIcon"
}, ao = {
  ref: "clickableText",
  class: "tasUpload__insertDocs",
  "t-sel": "insertDocumentsLabel"
}, lo = {
  key: 1,
  "t-sel": "acceptedFileTypesLabel"
}, uo = {
  key: 2,
  class: "tasUpload__documents"
}, po = {
  key: 1,
  class: "tasUpload__form-buttons"
};
function co(e, t, o, n, s, l) {
  const i = D("select-item-comp"), r = D("input-comp"), p = D("icon-comp"), m = D("i18n-t"), C = D("document-card"), v = D("button-comp");
  return u(), U($e(e.useForm ? "form" : "div"), {
    class: "tasUpload",
    onSubmit: t[9] || (t[9] = we(() => {
    }, ["prevent"]))
  }, {
    default: F(() => [
      e.showInputs ? (u(), c("div", {
        key: e.reRenderComponentKey,
        class: "tasUpload__form"
      }, [
        e.showDocumentTypeSelect ? (u(), U(i, {
          key: 0,
          class: "tasUpload__selectDocument",
          options: e.documentTypesForDropdown,
          modelValue: e.documentTypeSelected,
          "onUpdate:modelValue": [
            t[0] || (t[0] = (a) => e.documentTypeSelected = a),
            e.selectDocumentType
          ],
          errorMessages: e.errorMessages,
          "onUpdate:errorMessages": t[1] || (t[1] = (a) => e.errorMessages = a),
          label: e.$t("commonComps.documentUpload.selectDocumentType"),
          validationRules: [e.rules.required],
          selectWhite: "",
          width: "100%",
          "t-sel": "documentTypeSelector"
        }, null, 8, ["options", "modelValue", "errorMessages", "onUpdate:modelValue", "label", "validationRules"])) : h("", !0),
        e.showDocumentTypeLabel ? (u(), c("div", no, T(e.$t("commonComps.documentUpload.documentType", {
          docType: e.documentTypeNamesProvided[0]
        })), 1)) : h("", !0),
        e.showMetadata ? (u(), c("div", so, [
          (u(!0), c(q, null, G(e.metadata, (a) => (u(), c("div", {
            key: a == null ? void 0 : a.name
          }, [
            a.hideFieldFromUser ? h("", !0) : (u(), U(r, {
              key: 0,
              class: "tasUpload__form-text-input",
              modelValue: a.value,
              "onUpdate:modelValue": (f) => a.value = f,
              errorMessages: e.errorMessages,
              "onUpdate:errorMessages": t[2] || (t[2] = (f) => e.errorMessages = f),
              label: e.getMetaDataTitle(a),
              placeholder: e.getPlaceholderText(a),
              "validation-rules": e.useRules(a),
              disabled: a.disabled,
              "t-sel": `${e.getMetaDataTitle(a)}Input`
            }, null, 8, ["modelValue", "onUpdate:modelValue", "errorMessages", "label", "placeholder", "validation-rules", "disabled", "t-sel"]))
          ]))), 128))
        ])) : h("", !0)
      ])) : h("", !0),
      N("div", {
        onDragstart: t[4] || (t[4] = (...a) => e.handleDragOver && e.handleDragOver(...a)),
        onDragover: t[5] || (t[5] = (...a) => e.handleDragOver && e.handleDragOver(...a)),
        onDragenter: t[6] || (t[6] = (...a) => e.handleDragEnter && e.handleDragEnter(...a)),
        onDragleave: t[7] || (t[7] = (...a) => e.handleDragLeave && e.handleDragLeave(...a)),
        onDrop: t[8] || (t[8] = (...a) => e.handleDrop && e.handleDrop(...a)),
        ref: "dropzoneElement",
        class: ie({
          dropzone: !0,
          tasUpload__dropzone: !0,
          "tasUpload__dropzone--dragging": e.dragging,
          "tasUpload__dropzone--disabled": e.disabled
        })
      }, [
        e.isExternalCustomerView ? W(e.$slots, "default", { key: 0 }, void 0, !0) : (u(), c("div", ro, [
          e.showRemoveFiles ? (u(), c("div", {
            key: 0,
            onClick: t[3] || (t[3] = (...a) => e.removeAllDocuments && e.removeAllDocuments(...a)),
            class: "tasUpload__dropzone-clear-all",
            "t-sel": "removeAllDocumentsButton"
          }, T(e.$t("commonComps.documentUpload.removeFiles")), 1)) : h("", !0),
          N("div", io, [
            w(p, {
              icon: "cloud_upload_large",
              label: e.$t("commonComps.documentUpload.upload")
            }, null, 8, ["label"])
          ], 512),
          w(m, {
            scope: "global",
            tag: "p",
            class: "tasUpload__upload-header",
            keypath: "commonComps.documentUpload.maxFiles"
          }, {
            maxFiles: F(() => [
              M(T(e.maxFiles), 1)
            ]),
            maxFileSize: F(() => [
              M(T(e.maxFilesize), 1)
            ]),
            br: F(() => []),
            _: 1
          }),
          K(N("p", ao, " Insert your documents here ", 512), [
            [X, !e.documentUploads.length]
          ]),
          e.showAcceptedFileTypesMsg ? (u(), c("p", lo, T(e.acceptedFileTypesString), 1)) : h("", !0)
        ])),
        e.hideDocumentCards ? h("", !0) : K((u(), c("div", uo, [
          (u(!0), c(q, null, G(e.documentUploads, (a, f) => (u(), U(C, {
            key: f,
            document: a,
            uploading: e.isUploading,
            onDocRemoved: e.removeDocument
          }, null, 8, ["document", "uploading", "onDocRemoved"]))), 128))
        ], 512)), [
          [X, e.documentUploads.length > 0]
        ])
      ], 34),
      e.hideButtons ? h("", !0) : (u(), c("div", po, [
        W(e.$slots, "button", {
          submitClick: e.submitClick,
          disableButton: !e.showButton,
          uploading: e.uploading
        }, () => [
          w(v, {
            onClick: e.submitClick,
            class: "tasUpload__form-buttons-button",
            type: "submit",
            disabled: !e.showButton,
            waiting: e.uploading,
            legacyOrange: "",
            "t-sel": "submitButton"
          }, {
            default: F(() => [
              M(T(e.$t("common.submit")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled", "waiting"]),
          e.hideCancelButton ? h("", !0) : (u(), U(v, {
            key: 0,
            onClick: e.cancelButton,
            class: "tasUpload__form-buttons-button",
            type: "button",
            disabled: e.uploading,
            legacyOrange: "",
            "t-sel": "cancelButton"
          }, {
            default: F(() => [
              M(T(e.$t("common.cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]))
        ], !0)
      ]))
    ]),
    _: 3
  }, 32);
}
const ge = /* @__PURE__ */ de(oo, [["render", co], ["__scopeId", "data-v-b07c4d53"]]), mo = (e) => {
  e.component("TasUpload", ge);
}, vo = {
  TasUpload: ge,
  install: mo
};
export {
  vo as default
};
//# sourceMappingURL=technicalAssetUpload.js.map
